import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, Component, createRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  Badge,
} from "reactstrap";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import TableActiveComponent from "./Components/TableActiveComponent";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { AvForm } from "availity-reactstrap-validation";
import apiResponse from "../../../../services/apiResponse";
import DataTableBloc from "./Blocs/DataTableBloc";
import moment from "moment";

var reformatWorkUnit = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.work_unit_name_full;
    newObj["value"] = data.work_unit_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

// var reformatAtasan = function (datas) {
//   return datas.map(function (data) {
//     var newObj = {};
//     newObj["label"] = data.employee_name + " (" + data.position_name + ")";
//     newObj["value"] = data.employee_uuid;
//     newObj["model"] = data;
//     return newObj;
//   });
// };

var reformatAtasan = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    if (data.position_name != "Semua Data") {
      newObj["label"] = data.employee_name + " (" + data.position_name + ")";
    } else {
      newObj["label"] = data.position_name;
    }
    newObj["value"] = data.position_uuid;
    // newObj["value"] = data.employee_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

const formatDateWithTime = (value) => {
  if (value != "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    const time = date.toLocaleTimeString("id-ID");
    return (
      day +
      " " +
      month +
      " " +
      year +
      " " +
      time.substring(0, 5).replace(/\./g, ":")
    );
  } else {
    return value;
  }
};

class IndexView extends Component {
  historyMonth = "verifikasi_history_month_tunsus"; //
  historyYear = "verifikasi_history_year_tunsus"; //
  defaultOrder = "special_allowance_summary_id"; // orderBy
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
      (this.userdata.echelon_code.startsWith("1") ||
        this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;
  role = localStorage.getItem("currentRoleId");
  dataTableBloc = new DataTableBloc();
  constructor(props) {
    super(props);
    this.state = {
      confirmInfo: "Apakah anda yakin akan menyimpan data ini?",
      dataForm: {},
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      hirarkiOptions: [],
      workUnitOptions: [],
      atasanOptions: [],
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),
      hirarkiSelected: "",
      roleId: localStorage.getItem("currentRoleId"),
      positionSelected: "",
      atasanSelected:
        this.role == 2 && this.is_eselon == 1
          ? this.userdata.employee_uuid
          : "",
      workUnitSelected: "",
      generate_verification_status: 0,
      generate_verification_date: "",
      generate_verification_by: "",
      showUpload: false,
      document: null,
    };
    this.activeRef = createRef();
  }
  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }

  getMonthName(monthNumber) {
    const monthNamesId = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    // Ensure the monthNumber is within a valid range (1-12)
    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNamesId[monthNumber - 1]; // Adjusting for 0-based array indexing
    } else {
      return "Invalid Month";
    }
  }

  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }
  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        special_allowance_summary_month: this.state.month,
        special_allowance_summary_year: this.state.year,
      },
      confirm: true,
    });
  };
  submitData = async () => {
    // await this.createBloc.fetchCreate(
    //   this.convertToFormData(this.state.dataForm)
    // );
  };
  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }
    return formData;
  }

  handleGenerateUlang() {
    this.dataTableBloc.fetchRegenerate({
      year: this.state.year,
      month: this.state.month,
    });
  }

  handleButtonVerifikasi() {
    this.dataTableBloc.fetchVerifikasi({
      year: this.state.year,
      month: this.state.month,
      employee_uuid: this.userdata.employee_uuid,
      type: 4,
    });
  }

  handleCekVerifikasi() {
    this.dataTableBloc.cekVerifikasi({
      year: this.state.year,
      month: this.state.month,
    });
  }

  listAtasan = async () => {
    // this.setState({
    //   is_eselon: this.getEselon(),
    //   positionSelected: this.getPosition(),
    // });
    this.dataTableBloc.fetchAtasan({
      year: this.state.year,
      month: this.state.month,
      roleId: this.state.roleId,
      is_echelon: this.state.is_eselon,
    });
    // }
  };
  openVerification = async () => {
    await this.dataTableBloc.openVerification({
      year: this.state.year,
      month: this.state.month,
      description: this.userdata?.employee_full_name,
      nip: this.userdata?.employee_nip,
      type: 4 // tunsus
    })
  }
  fixMinioUrl = (brokenUrl) => {
    // 1. Decode sekali
    let once = decodeURIComponent(brokenUrl);

    // 2. Ambil hanya URL dari "https://" kedua
    const idx = once.indexOf("https://", 8);
    if (idx !== -1) {
      once = once.substring(idx);
    }

    // 3. Ambil hanya satu set query params
    const q1 = once.indexOf("?");
    const q2 = once.indexOf("?", q1 + 1);
    if (q1 !== -1 && q2 !== -1) {
      once = once.substring(0, q2);
    }

    return once;
  }
  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        if (this.state.runType == 1) {
          this.submitData();
        }

        if (this.state.runType == 2) {
          this.handleGenerateUlang();
        }

        if (this.state.runType == 3) {
          this.handleButtonVerifikasi();
        }
        if (this.state.runType == 10) {
          this.openVerification()
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          showUpload: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  handleButtonExport() {
    this.activeRef.current.handleButtonExport();
  }
  componentDidMount() {
    this.dataTableBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              workUnitOptions: reformatWorkUnit(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.listAtasanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              atasanOptions: reformatAtasan(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.cekVerifikasiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            if (response) {
              this.setState({
                generate_verification_status:
                  response.verification_data_is_verif_tunsus
                    ? response.verification_data_is_verif_tunsus
                    : 0,
                generate_verification_date:
                  response.verification_data_created_date
                    ? response.verification_data_created_date
                    : "",
                generate_verification_by: response.employee_full_name,
              });
            } else {
              this.setState({
                generate_verification_status: 0,
                generate_verification_date: "",
                generate_verification_by: "",
              });
            }
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.generateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              loading: false,
            });
            this.activeRef.current.setTokenAPI();
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.dataTableBloc.openverificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.activeRef.current.setTokenAPI();
          this.handleCekVerifikasi();
          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    })
    this.dataTableBloc.verifikasiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          let response = result.data.response;
          if (result.data.status) {
            this.setState({
              loading: false,
              success: true,
            });
            this.handleCekVerifikasi();
            this.activeRef.current.setTokenAPI();
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.handleCekVerifikasi();
    this.dataTableBloc.fetchWorkUnit({ status: 1 });
    // if (this.is_eselon == 1 || this.state.roleId == 1) {
    this.listAtasan();
    // this.dataTableBloc.fetchAtasan({
    //   roleId: this.state.roleId,
    //   is_echelon: this.is_eselon,
    //   year: this.state.year,
    //   month: this.state.month,
    // });
    // }
  }

  componentWillUnmount() {
    this.dataTableBloc.workUnitChannel?.unsubscribe();
    this.dataTableBloc.listAtasanChannel?.unsubscribe();
    this.dataTableBloc.generateChannel?.unsubscribe();
    this.dataTableBloc.verifikasiChannel?.unsubscribe();
    this.dataTableBloc.cekVerifikasiChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Verifikasi Capaian Kinerja Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    Daftar Verifikasi Capaian Kinerja Pegawai
                  </CardSubtitle>
                  <hr />

                  {/* Start of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}
                  {this.is_eselon == 1 || this.state.roleId == 1 ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Pembayaran{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />
                        </Col>

                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Atasan Langsung <span className="text-danger">*</span>
                        </label>
                        <Col md="10">
                          <CustomSelect
                            name="work_unit_hirarki"
                            errorMessage="Pilih Atasan"
                            options={this.state.atasanOptions}
                            placeholder="Pilih Atasan"
                            // defaultValue={
                            //   this.state.roleId == 2 && this.is_eselon == 1
                            //     ? this.state.atasanSelected
                            //     : ""
                            // }
                            // onChange={(v) =>
                            //   this.setState({
                            //     atasanSelected: v.value,
                            //     positionSelected: v.model.position_uuid,
                            //   })
                            // }
                            defaultValue={
                              this.state.roleId == 2
                                ? localStorage.getItem(
                                  "verifikasiCurrentPositionUuid"
                                )
                                  ? localStorage.getItem(
                                    "verifikasiCurrentPositionUuid"
                                  )
                                  : this.state.positionSelected
                                : this.state.positionSelected
                            }
                            onChange={(v) => {
                              // if (this.state.roleId == 2) {
                              // localStorage.setItem(
                              //   "currentEchelonCode",
                              //   JSON.stringify(v.model.echelon_code)
                              // );
                              // localStorage.setItem(
                              //   "currentPositionUuid",
                              //   JSON.stringify(v.model.position_uuid)
                              // );
                              // localStorage.setItem(
                              //   "currentPositionName",
                              //   JSON.stringify(v.model.position_name)
                              // );

                              // // kondisi kalau misalkan pilih semua data atasan
                              // if (v.model.employee_uuid) {
                              //   localStorage.setItem(
                              //     "currentEmployeeUuid",
                              //     JSON.stringify(v.model.employee_uuid)
                              //   );
                              // } else {
                              //   localStorage.removeItem("currentEmployeeUuid");
                              // }

                              // }
                              this.setState({
                                atasanSelected: v.model.employee_uuid,
                                positionSelected: v.value,
                              });
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row
                        className="mb-3"
                        style={{
                          display: "none",
                        }}
                      >
                        <label
                          htmlFor="work_unit"
                          className="col-md-2 col-form-label"
                        >
                          Unit Kerja <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="work_unit"
                            errorMessage="Pilih Unit Kerja"
                            options={this.state.workUnitOptions}
                            placeholder="Pilih Unit Kerja"
                            // defaultValue={this.state.month}
                            onChange={(v) =>
                              this.setState({ workUnitSelected: v.value })
                            }
                            isAvForm={false}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                  {/* End  of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}

                  {/* Start of : Menu Filter Pegawai yang bukan eselon 1 & 2  */}
                  {this.is_eselon == 0 && this.state.roleId == 2 ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Bulan <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Tahun <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Nama
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_full_name}
                          </label>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          NIP
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_nip}
                          </label>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Jabatan
                        </label>
                        <Col md="6">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_current_position_name}
                          </label>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Unit Kerja
                        </label>
                        <Col md="6">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_current_work_unit_name}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                  {/* End  of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}

                  <Row className="mb-3">
                    <Col md="2"></Col>
                    <Col md="8">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          this.activeRef.current.setTokenAPI();
                          this.handleCekVerifikasi();
                          this.listAtasan();
                        }}
                      >
                        <i className="uil-search-alt"></i> Cari
                      </Button>{" "}
                      {/* Start of : Tombol Upload E-Kinerja, Generate, Verifikasi, Export untuk Administrator */}
                      {this.state.roleId == 1 ? (
                        <>
                          <Button
                            color="success"
                            type="button"
                            onClick={() => {
                              this.setState({
                                confirm: true,
                                runType: 2,
                                confirmInfo:
                                  "Apakah anda yakin akan melakukan proses Generate Ulang?",
                              });
                            }}
                            disabled={
                              this.state.generate_verification_status == 1
                                ? true
                                : false
                            }
                          >
                            <i className="uil-refresh"></i> Generate Ulang
                            Periode{" "}
                            {this.getMonthName(this.state.month) +
                              " " +
                              this.state.year}{" "}
                          </Button>{" "}
                          <Button
                            color="warning"
                            type="button"
                            disabled={
                              this.state.generate_verification_status == 1
                                ? true
                                : false
                            }
                            onClick={() => {
                              this.setState({
                                confirm: true,
                                runType: 3,
                                confirmInfo:
                                  "Apakah anda yakin akan melakukan Verifikasi Tunjangan Khusus?",
                              });
                            }}
                          >
                            <i className="uil-checklist"></i>
                            {this.state.generate_verification_status == 1
                              ? "Sudah Verifikasi"
                              : "Verifikasi"}
                          </Button>{" "}
                          {' '}
                          <Button
                            color="danger"
                            className="me-2"
                            onClick={() => this.setState({
                              confirm: true,
                              runType: 10,
                              confirmInfo: "Apakah anda yakin akan membuka ulang hasil verifikasi Tunjangan Khusus?"
                            })}
                            style={{ display: ((this.state.generate_verification_status == 1) ? '' : 'none') }}
                          >
                            Buka Verifikasi
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                      {/* End of : Tombol Upload E-Kinerja, Generate, Verifikasi, Export untuk Administrator */}
                    </Col>

                    <Col md="2">
                      {this.state.roleId == 1 ? (
                        <Button
                          color="warning"
                          type="button"
                          className={classnames("float-end")}
                          onClick={() => {
                            this.handleButtonExport();
                          }}
                        >
                          <i className="uil-file-download"></i> Export Xls {((this.state.generate_verification_status == 1) ? formatDateWithTime(
                            this.state.generate_verification_date
                          ) : '')}
                        </Button>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="8">
                      <br></br>
                      {this.state.generate_verification_status == 0 ? (
                        <b>
                          Status Verifikasi Tunjangan Khusus Periode{" "}
                          {this.getMonthName(this.state.month) +
                            " " +
                            this.state.year}{" "}
                          :{" "}
                          <Badge className="badge bg-danger font-size-14">
                            {" "}
                            Belum Dilakukan Verifikasi{" "}
                          </Badge>
                        </b>
                      ) : this.state.generate_verification_status == 1 ? (
                        <b>
                          Status Verifikasi Tunjangan Khusus Periode{" "}
                          {this.getMonthName(this.state.month) +
                            " " +
                            this.state.year}{" "}
                          :{" "}
                          <Badge className="badge bg-success font-size-14">
                            {" "}
                            Telah dilakukan Verifikasi oleh{" "}
                            {this.state.generate_verification_by} pada tanggal{" "}
                            {formatDateWithTime(
                              this.state.generate_verification_date
                            )}
                          </Badge>
                        </b>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>

                  <hr />
                  <TableActiveComponent
                    ref={this.activeRef}
                    setDocument={(doc) => this.setState({ document: doc })}
                    additionalFilter={{
                      year: this.state.year,
                      month: this.state.month,
                      workunit: this.state.workUnitSelected,
                      employee_uuid: this.state.atasanSelected,
                      position_uuid: this.state.positionSelected,
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil disimpan"
            failedTitle="Gagal!"
            failedInfo="Data gagal disimpan"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
          <Modal size={"lg"} isOpen={this.state.showUpload}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myLargeModalLabel">
                Upload Data E-Kinerja
              </h5>
              <button
                onClick={() => {
                  this.setState({
                    showUpload: false,
                  });
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <div className="modal-body">
                <a
                  href={
                    process.env.REACT_APP_SERVICE_CORE_URL +
                    "/templates/Template_SKP.xlsx"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Unduh template...
                </a>
                <br />
                <br />
                <FileInput
                  name="special_allowance_summary_doc"
                  validate={{ required: { value: false } }}
                  maxFiles={1}
                />
              </div>
              <div className="modal-footer">
                {this.state.document && (
                  <a
                    href={this.state.document?.documents_path}
                    target="_blank"
                    className="me-auto"
                  >
                    Download Document Sebelum nya
                  </a>
                )}
                <Button
                  color="success"
                  type="submit"
                  onClick={() => {
                    this.setState({
                      confirm: true,
                      runType: 1,
                      confirmInfo:
                        "Apakah anda yakin akan melakukan Upload Data E-Kinerja?",
                    });
                  }}
                >
                  Simpan Data
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={() => {
                    this.setState({
                      showUpload: false,
                    });
                  }}
                >
                  Cancel
                </Button>
              </div>
            </AvForm>
          </Modal>
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;
